'use client'
import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Typography } from '@mui/material'
import { ElementContainer } from './Ui'
import { BaseComponentProps, HeadingDomElement } from './Ui'
import { convertToKebabCase } from '../../../utils/utils'
import { v4 as uuidv4 } from 'uuid'

interface Item {
  title: string
  content: string
}

export interface MuiAccordionProps extends BaseComponentProps {
  items: Item[]
  domElement: HeadingDomElement
}

const MuiAccordion = ({
  items,
  domElement,
  spacingBottomMobile,
  spacingBottomDesktop
}: MuiAccordionProps) => {
  return (
    <ElementContainer
      sx={{
        marginBottom: {
          xs: spacingBottomMobile,
          md: spacingBottomDesktop
        }
      }}
    >
      {items.map((item, index) => {
        const tagId = `tag_${convertToKebabCase(item.title)}`
        const panelId = `panel${index + 1}`
        
        return (
          <Accordion key={uuidv4()} id={tagId} sx={{ zIndex: 1 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon id={`${tagId}-expand-icon`}/>}
              aria-controls={panelId}
              id={`${tagId}-title-container`}
              aria-label={item.title}
            >
              <Typography variant="titleSmall" component={domElement} sx={{ marginBottom: 0, width: '100%', height: '100%' }} id={`${tagId}-title`}>
                {item.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <p>{item.content}</p>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </ElementContainer>
  )
}

export default MuiAccordion
